import React from "react";
import { TableHeaderColumns } from "../TableHeaderColumns";
import { TableBodyRows } from "../TableBodyRows";
import { useSimpleTableContext } from "../../../contexts/SimpleTableContext";
import type { BaseEntity } from "../../../types";

/**
 * Renders table body section of SimpleTableDesktopView
 * Includes table header columns and body rows
 * Consumes data directly from SimpleTableContext
 */
export function SimpleTableBodySection<TData extends BaseEntity>() {
  const context = useSimpleTableContext<TData>();
  const { hideColumnHeaders } = context;

  return (
    <div className="flex min-w-full w-max flex-col">
      {/* Table Header - Hidden in card view */}
      {!hideColumnHeaders && (
        <TableHeaderColumns />
      )}

      {/* Table Body */}
      <TableBodyRows />
    </div>
  );
}
